import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { remindersAnalyticsReducer } from './reminders-analytics.reducer';
import { RemindersAnalyticsEffects } from './reminders-analytics.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('remindersAnalytics', remindersAnalyticsReducer),
    EffectsModule.forFeature([RemindersAnalyticsEffects])
  ]
})
export class RemindersAnalyticsStateModule {}
